import React from 'react';
import _ from 'lodash';
import styled, { ThemeProvider, withTheme } from 'styled-components';
import { FavExRow } from '../components';

const List = styled.div`
  height: auto;
  overflow: scroll;
`;

const FavExList = ({ theme, exchanges, selectExchange }) => (
  <ThemeProvider theme={theme}>
    <List>
      {_.map(exchanges, exchange => <FavExRow selectExchange={selectExchange} exchange={exchange} key={exchange.id} />)}
    </List>
  </ThemeProvider>
);

export default withTheme(FavExList);



// WEBPACK FOOTER //
// ./src/components/FavExList.js